export default __webpack_public_path__ + "static/media/exclude.b72d3121.svg";